import $ from 'jquery';
import 'slick-carousel';

$('.dsp-collapse .collapse-link').on('click', function (e) {
  e.preventDefault();
  const $nav = $(this).closest('.collapse-nav');

  const wasActive = $nav.hasClass('is-active');
  const selfCollapse = $nav.data('self-collapse');

  // get the pane to be activated
  const $pane = $($(this).attr('href'));

  if (!wasActive) {
    // position any slider
    if ($pane.data('slider')) {
      setTimeout(() => {
        $(`.${$pane.data('slider')}`).slick('setPosition');
      }, 10);
    }

    // show this pane
    $pane.toggleClass('is-active');
    $(this).toggleClass('is-active');
 
    // activate this tab
    $pane.closest('.collapse-nav').toggleClass('is-active');
  } else {
    if (selfCollapse) {
      // show this pane
      $pane.toggleClass('is-active');
      $(this).toggleClass('is-active');

      // activate this tab
      $pane.parents('.collapse-nav').toggleClass('is-active');
    }
  }
});
